import React from "react";

export default function MileageSkeletonLoader() {
  return (
    <div className="lines ch-mt--2 ch-height--12 ch-width--11 ch-display--flex ch-flex-flow--column-wrap ch-justify-content--start">
      <div className="thumb ch-skeleton ch-width--12 " />
      <div className="line ch-skeleton ch-width--7" />
      <div className="line ch-skeleton ch-width--7" />
      <div className="thumb bottom ch-skeleton ch-width--12" />
    </div>
  );
}
